import { useEffect, useRef, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import { showLoading, hideLoading } from '../../reducers/loading';
import api from '../../services/api';
import { trackPageView } from '../../services/tracking';
import { updateReducerAndForm } from '../../services/subscription';
import { sendRollbarError } from '../../services/rollbar';
import Pluralize from 'react-pluralize';

import { PageBottom } from '../pageBottom';
import { Button } from '../button';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';
import { ErrorLabel } from '../input';
import { Input } from '../input';
import Numeral from '../numeral';
import Selectable from '../selectable';
import Products from './products'

import Summary from '../summary';

import { StyledPlan } from './style';

import oneBagIcon from '../../assets/one-bag.svg';
import twoBagsIcon from '../../assets/two-bags.svg';
import fourBagsIcon from '../../assets/four-bags.svg';
import popularTag from '../../assets/popular.svg';

const icons = {
  oneBag: oneBagIcon,
  twoBags: twoBagsIcon,
  fourBags: fourBagsIcon,
}

const PlanShipping = (props) => {
  if(props.shippingPrice > 0) {
    return (
      <span className="plan-shipping">
        + frete: <strong><Numeral value={props.shippingPrice} format="$ 0,0.00" /></strong>
      </span>
    )
  }
  else if (props.shippingPrice === 0){
    return (
      <span className="plan-shipping">
        <div className="plan-free-shipping">Frete grátis!</div>
      </span>
    )
  }
  else return null;
}

const Plan = (props) => {
  const formikRef = useRef();
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);
  const brewingMethods = useSelector((state) => state.brewingMethods)

  const initialValues = { ...subscription };

  const [plans, setPlans] = useState([]);
  const [plan, setPlan] = useState(null);
  const [brewingMethodOptions, setBrewingMethodOptions] = useState([])
  const [brewingMethodOption, setBrewingMethodOption] = useState(subscription.brewingMethodOption)

  const loadPlans = (zipcode) => {
    dispatch(showLoading('Carregando...'));

    api.get('/subscriptions/plans', {
      params: {
        zipcode: zipcode
      }
    }).then((response) => {
      if(response.data){
        setPlans(response.data.plans);
      }
    }).catch((e) => {
      sendRollbarError('ERROR: /subscriptions/plans', { message: e.message });
    }).then(() => {
      dispatch(hideLoading());
    });
  }

  const handleClick = (plan) => {
    setPlan(plan);
  }

  const handleBrewingMethodChange = (e) => {
    let value = e.target ? e.target.value : ''

    if(parseInt(value) >= -1){
      value = parseInt(value)
    }
    
    formikRef.current.setFieldValue('brewingMethodOption', value)
    setBrewingMethodOption(value)

    dispatch(updateSubscription({
      brewingMethodOption: value
    }));
  }

  const validate = (values) => {
    const errors = {};

    if (!values.quantity){
      errors.quantity = 'Escolha uma quantidade para continuar';
    }
    if (!(parseInt(values.brewingMethodOption) >= -1)){
      errors.brewingMethodOption = 'Escolha a moagem para continuar';
    }

    return errors;
  }

  const handleSubmit = (values) => {
    dispatch(completeStep(2));
    props.history.push('/entrega');
  }

  useEffect(() => {
    updateReducerAndForm({
      orderType: 2,
      coffees: {},
    }, formikRef.current.setFieldValue);

    let plan = plans.find(plan => plan.quantity === subscription.quantity);
    setPlan(plan);

    if(window['$']('.current.selectable')[0]){
      window['$']('.current.selectable')[0].scrollIntoView({
        block: 'center',
        inline: 'center'
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plans]);

  useEffect(() => {
    if(plan){
      updateReducerAndForm({
        quantity: plan.quantity,
        shippingPrice: plan.shippingPrice,
        deliveryTime: plan.deliveryTime,
        itemsToFreeShipping: plan.itemsToFreeShipping,
      }, formikRef.current.setFieldValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plan]);

  useEffect(() => {
    let ground = 'false'
    let brewingMethod = ''
    
    if(parseInt(brewingMethodOption) >= -1){
      if(parseInt(brewingMethodOption) === -1){
        ground = 'false'
        brewingMethod = 2
      }
      else {
        ground = 'true'
        brewingMethod = brewingMethodOption
      }
    }

    updateReducerAndForm({
      brewingMethod: brewingMethod,
      ground: ground,
    }, formikRef.current.setFieldValue);
  }, [brewingMethodOption])

  useEffect(() => {
    let options = [{ value: -1, label: 'Em grãos' }]

    brewingMethods.map((brewingMethod) => (
      options.push({
        value: brewingMethod.id.toString(),
        label: `Moído para ${brewingMethod.name} (${brewingMethod.grind})`
      })
    ))

    setBrewingMethodOptions(options)
  }, [brewingMethods])

  useEffect(() => {
    dispatch(updateSubscription({ planPage: 'plan' }));
    loadPlans(subscription.zipcode);

    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledPlan>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({ values }) => (
          <Form>
            <PageHeader>
              <small>Sua caixinha</small>
              <h1>Escolha o plano ideal pra você!</h1>

              <p>
              Receba cafés de qualidade, de diferentes regiões do Brasil e sem sair de casa.
              </p>
            </PageHeader>

            {values.itemsToFreeShipping > 0 && <div className="items-to-free-shipping">
              Adicione mais <strong><Pluralize singular="café" count={values.itemsToFreeShipping} /></strong> ganhe frete grátis :)
            </div>}

            <div className="plans-wrapper">
              <div className="plans">
                {plans.map((plan, i) => {
                  let className = values.quantity === plan.quantity ? 'current' : ''

                  return <div key={i} className={`plan-option ${className}`} onClick={() => handleClick(plan)}>
                    <Selectable className={className}>
                      {plan.popular ? <img className="popular-tag" src={popularTag} alt="" /> : ''}
              
                      <div className="plan-icon">
                        <img src={icons[plan.icon]} alt={plan.title} />
                      </div>
              
                      <div className="title">{plan.title}</div>
                      <div className="description">{plan.description}</div>

                      {plan.items.length && <ul className="plan-items">
                        {plan.items.map((item, i) => (
                          <li key={i} className="item">{item}</li>
                        ))}
                      </ul>}
              
                      <div className="price">
                        <strong className="plan-price"><Numeral value={plan.price} format="$ 0,0.00" /></strong>
                        <small> / Envio</small>

                        <PlanShipping shippingPrice={plan.shippingPrice} />
                      </div>
                    </Selectable>
                  </div>
                })}
              </div>
            </div>

            <Products formikRef={formikRef} />

            <div className="brewing-method-box">
              <Input
                name="brewingMethodOption"
                as="select"
                label="Em grãos ou moído?"
                onChange={handleBrewingMethodChange}
                options={brewingMethodOptions}
              />
            </div>

            <div className="errors-box">
              <ErrorLabel name="quantity" />
            </div>

            <PageBottom>
              <h4>Nenhuma das quantidades acima te atende?</h4>

              <Link to="/quantidade-personalizada">Escolha a sua quantidade</Link>

              <span className="or">Ou</span>

              <Link to="/personalizar">Escolha seus próprios cafés</Link>
            </PageBottom>

            <Summary />

            <FormActions backUrl="/perfil" backDescription="Dados pessoais">
              <Button
                type="submit"
                icon="angle-right"
                align="right"
                description="Endereço de entrega"
              >
                Continuar
              </Button>
            </FormActions>
          </Form>
        )}
      </Formik>
    </StyledPlan>
  )
}

export default withRouter(Plan);
